import React from 'react';
import type { Portfolio } from 'venn-api';
import { useAllocationSearch } from './AllocationSearchContext';
import { AllocationSearchWrapper } from './AllocationSearchWrapper';

interface AllocationSearchConstituentViewProps {
  nodeRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  constituents: Portfolio[];
}

export const AllocationSearchConstituentView: React.FC<AllocationSearchConstituentViewProps> = ({
  nodeRef,
  onClose,
  constituents,
}) => {
  const { handleConstituentSelect } = useAllocationSearch();

  return (
    <AllocationSearchWrapper nodeRef={nodeRef} onClose={onClose} title="Add investment to…">
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="overflow-y-auto max-h-[380px]">
          <ul className="list-none m-0 p-0 border-t border-x-0 border-b-0 border-solid border-venn-grey-30">
            {constituents.map((constituent) => (
              <li key={constituent.id}>
                <button
                  type="button"
                  onClick={() => handleConstituentSelect(constituent)}
                  className="qa-constituent-option w-full text-left border border-x-0 border-t-0 border-solid border-venn-grey-30 px-[16px] py-[8px] text-venn-black hover:bg-venn-grey-10 hover:text-venn-black"
                >
                  {constituent.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </AllocationSearchWrapper>
  );
};
